/*
 * Copyright 2010-2016 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */
import buffer from 'buffer'

const utils = {
  assertDefined: function (object, name) {
    if (object === undefined) {
      throw new Error(`${name} must be defined`)
    } else {
      return object
    }
  },
  assertParametersDefined: function (params, keys, ignore) {
    if (keys === undefined) {
      return
    }
    if (keys.length > 0 && params === undefined) {
      params = {}
    }
    for (let i = 0; i < keys.length; i++) {
      if (!utils.contains(ignore, keys[i])) {
        utils.assertDefined(params[keys[i]], keys[i])
      }
    }
  },
  parseParametersToObject: function (params, keys) {
    if (params === undefined) {
      return {}
    }
    const object = {}
    for (let i = 0; i < keys.length; i++) {
      object[keys[i]] = params[keys[i]]
    }
    return object
  },
  contains: function (a, obj) {
    if (a === undefined) {
      return false
    }
    let i = a.length
    while (i--) {
      if (a[i] === obj) {
        return true
      }
    }
    return false
  },
  copy: function (obj) {
    if (obj === null || typeof obj !== 'object') return obj
    const Buffer = buffer.Buffer
    if (Buffer.isBuffer(obj)) return Buffer.from(obj)
    const copy = obj.constructor()
    let attr = null
    for (attr in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = obj[attr]
    }
    return copy
  },
  mergeInto: function (baseObj, additionalProps) {
    if (baseObj === null || typeof baseObj !== 'object') return baseObj
    const merged = baseObj.constructor()
    let attr = null
    for (attr in baseObj) {
      if (Object.prototype.hasOwnProperty.call(baseObj, attr)) merged[attr] = baseObj[attr]
    }
    if (additionalProps == null || typeof additionalProps !== 'object') return baseObj
    for (attr in additionalProps) {
      if (Object.prototype.hasOwnProperty.call(additionalProps, attr)) {
        merged[attr] = additionalProps[attr]
      }
    }
    return merged
  }
}

export default utils
